
(function ($) {

    $(document).ready(function () {

        $(window).scroll(function(){
            // This is then function used to detect if the element is scrolled into view

            function elementScrolled(elem) {
                var docViewTop = $(window).scrollTop();
                var docViewBottom = docViewTop + $(window).height();
                var elemTop = $(elem).offset().top;
                var elemBottom = elemTop + $(elem).height();

                return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop)) ||
                    ((elemTop <= docViewBottom) && (elemBottom >= docViewBottom)) ||
                    ((elemBottom >= docViewTop) && (elemTop <= docViewTop));
            }

            let counters = $('.should-count-in-view');
            counters.each( function(){
                console.log( elementScrolled(this ) );
                if(elementScrolled(this )) {
                    $(this).removeClass('should-count-in-view');
                    animateValue(this, 0, $(this).data('value'), $(this).data('duration') );
                }

            })

        });

        function animateValue(obj, start, end, duration) {
            console.log('Animating value');
            let startTimestamp = null;
            const step = (timestamp) => {
                if (!startTimestamp) startTimestamp = timestamp;
                const elapsed = timestamp - startTimestamp;
                const progress = Math.min(elapsed / duration, 1);
                obj.innerHTML = numberWithCommas(Math.floor(progress * (end - start) + start));
                if (progress < 1) {
                    window.requestAnimationFrame(step);
                }
            };
            window.requestAnimationFrame(step);
        }

        function numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }



    });

})( jQuery );